import { Check, ArrowRight } from "lucide-react";
import { useSeo } from "@/components/Layout";
import { RevealLines, Reveal, RevealHeading, Stagger, StaggerItem } from "@/components/motion-primitives";
import { CtaButton, SectionLabel } from "@/components/ui-blocks";
import { IMAGES } from "@/data/site";
import { useLang } from "@/i18n/LanguageContext";

export default function CoachingLigne() {
  const { t } = useLang();
  const l = t.ligne;
  useSeo(l.seoTitle, l.seoDesc);
  return (
    <div data-testid="coaching-ligne-page">
      {/* HERO 2-col */}
      <section className="max-w-8xl mx-auto px-5 sm:px-6 lg:px-12 pt-32 lg:pt-32 pb-14 lg:pb-20 grid lg:grid-cols-12 gap-8 lg:gap-14 items-center">
        <div className="lg:col-span-6">
          <SectionLabel>{l.label}</SectionLabel>
          <RevealLines as="h1" delay={0.1} className="display-hero text-ink mt-4" lines={l.heroLines} />
          <Reveal delay={0.4}><p className="mt-5 text-muted-foreground leading-relaxed">{l.sub}</p></Reveal>
          <Reveal delay={0.5} className="mt-6"><CtaButton to="/contact" data-testid="ligne-cta" className="w-full sm:w-auto justify-center">{l.cta}</CtaButton></Reveal>
        </div>
        <Reveal className="lg:col-span-6">
          <div className="relative aspect-[4/5] lg:aspect-[5/6] overflow-hidden bg-secondary max-w-md mx-auto lg:max-w-none">
            <img src={IMAGES.prepa} alt={l.imgAlt} className="w-full h-full object-cover object-center" />
          </div>
        </Reveal>
      </section>

      {/* INCLUDES */}
      <section className="bg-secondary/50 border-y border-border">
        <div className="max-w-8xl mx-auto px-5 sm:px-6 lg:px-12 py-14 lg:py-24">
          <RevealHeading as="h2" text={l.includes} className="display-2 text-ink mb-8" />
          <Stagger className="grid sm:grid-cols-2 lg:grid-cols-4 gap-x-6 gap-y-1" gap={0.05}>
            {l.items.map((it, i) => (
              <StaggerItem key={i} className="flex items-start gap-2.5 py-3 border-t border-border">
                <Check size={16} className="text-accentbrand mt-0.5 shrink-0" /><span className="text-sm text-ink">{it}</span>
              </StaggerItem>
            ))}
          </Stagger>
        </div>
      </section>

      {/* FLOW */}
      <section className="max-w-8xl mx-auto px-5 sm:px-6 lg:px-12 py-14 lg:py-24">
        <SectionLabel>{l.flowLabel}</SectionLabel>
        <Stagger className="mt-6 flex flex-wrap items-center gap-x-3 gap-y-4" gap={0.08}>
          {l.flow.map((step, i) => (
            <StaggerItem key={i} className="flex items-center gap-3">
              <span className="font-display text-2xl lg:text-4xl font-bold uppercase tracking-tight text-ink">{step}</span>
              {i < l.flow.length - 1 && <ArrowRight size={22} className="text-accentbrand" />}
            </StaggerItem>
          ))}
        </Stagger>
      </section>
    </div>
  );
}
